import { app } from "modular-openscriptjs";

const h = app("h");

export default function ViewProductModal(...args) {
    return h.$(
        h.div(
            { class: "modal-content border-0 rounded-5 shadow-lg" },
            h.div({ class: "modal-body p-5" }, ...args)
        )
    );
}